    import { Directive } from '@angular/core';
    import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
    @Directive({
        selector: '[appValueObjectValidator]',
        providers: [{ provide: NG_VALIDATORS, useExisting: ValueObjectValidatorDirective, multi: true }]
    })
    export class ValueObjectValidatorDirective implements Validator {
        validate(control: AbstractControl): ValidationErrors | null {
            if (control.value === null || control.value === undefined || control.value === '') {
                return null;
            }
            const isValid = typeof control.value === 'object' && control.value !== null;
            return isValid ? null : { valueObjectValidator: { value: control.value } };
        }
    }